import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, typography, shape, palette }) => ({
  container: {
    whiteSpace: 'nowrap',
  },
  chip: {
    padding: spacing(0.25),
    fontSize: typography.caption.fontSize,
    borderRadius: shape.borderRadius / 2,
    backgroundColor: palette.grey[200],
  },
  chipLabel: {
    fontWeight: typography.h6.fontWeight,
  },
  text: {
    position: 'relative',
    top: spacing(0.15),
    color: palette.warning.dark,
  },
  priceContainer: {
    marginBottom: spacing(1),
  },
}));
